import apiFetch from '../apiFetch'

export default function (idAlbaran) {
  return apiFetch({endPoint: `Albaran/imprimirDatosClienteAlbaran?idAlbaran=${idAlbaran}`, method: 'GET'})
}